export default "__VITE_ASSET__AN$uG$Iy__"